import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { getModule } from "../../../utils/ApiCalls/Permission";
import { initialData as livePermissionTree } from "./PermissionMenu";

const PermissionTable = ({ myPermission }) => {
  const [, dispatch] = useDataLayerValue();
  const [rows, setRows] = useState([]);

  //STATIC APPROASH AND EVEN NOT CONNECTED WITH API FOR PAGINATIONS -----
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Saved myPermission.permission_json is a per-user snapshot captured at grant
  // time, so a node's own `title` can go stale after a rename in PermissionMenu.js.
  // Resolve the display title live against the current tree instead - matched
  // sibling-by-sibling (liveNodes is always the matching level of the live tree),
  // not by a flat key map, since the same key (e.g. "/management") repeats under
  // different parents. Falls back to the saved title if the node no longer
  // exists in the live tree (e.g. a removed module).
  const flattenPermissions = (nodes, liveNodes = livePermissionTree, parentTitle = "") => {
    let result = [];
    nodes.forEach((node) => {
      const liveNode = liveNodes?.find((n) => n.key === node.key);
      const title = liveNode?.title ?? node.title;
      const fullTitle = parentTitle ? `${parentTitle} → ${title}` : title;

      if (node.permissions) {
        result.push({
          module_key: node.key,
          name: fullTitle,
          ...node.permissions,
        });
      }

      if (node.children && node.children.length > 0) {
        result = result.concat(flattenPermissions(node.children, liveNode?.children, fullTitle));
      }
    });
    return result;
  };

  useEffect(() => {
    if (myPermission?.permission_json) {
      const flattened = flattenPermissions(myPermission.permission_json);
      console.log(flattened, "FLATTENED ???");
      setRows(flattened);
    }
  }, [myPermission]);

  const columns = [
    {
      title: "Module",
      dataIndex: "name",
      key: "name",
      width: 500,
      align: "left",
      render: (item) => <span>{item}</span>,
    },
    {
      title: "View",
      dataIndex: "read",
      key: "read",
      render: (val) =>
        val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />,
    },
    {
      title: "Create",
      dataIndex: "write",
      key: "write",
      render: (val) =>
        val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />,
    },
    {
      title: "Update",
      dataIndex: "edit",
      key: "edit",
      render: (val) =>
        val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />,
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      render: (val) =>
        val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />,
    },
    {
      title: "Download",
      dataIndex: "download",
      key: "download",
      render: (val) =>
        val ? <CheckCircleIcon style={{ color: "green" }} /> : <CancelIcon style={{ color: "red" }} />,
    },
  ];

  return (
    <CustomizedTable
      setRows={setRows}
      setPageSize={setPageSize}
      setPage={setPage}
      pageSize={pageSize}
      page={page}
      count={count}
      columns={columns}
      rows={rows}
      title="Permission Overview"
    />
  );
};

export default PermissionTable;


// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import React, { useEffect, useState } from "react";
// import { useDataLayerValue } from "../../../DataLayer/DataLayer";

// import CancelIcon from "@mui/icons-material/Cancel";
// import CustomizedTable from "../../../components/UI/CustomizedTable";
// import { getModule } from "../../../utils/ApiCalls/Permission";
// const PermissionTable = ({ myPermission }) => {

//   console.log(JSON.stringify(myPermission), "PERMS ??")

//   const [rows, setRows] = useState([

//   ]);
//   const [count, setCount] = useState(0);
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [search, setSearch] = useState("");
//   const [, dispatch] = useDataLayerValue();
//   const columns = [
//     {
//       title: "Module",
//       dataIndex: "name",
//       key: "name",
//       width: 50,
//       render: (item) => <p style={{ fontWeight: "bold" }}>{item}</p>,
//     },

//     {
//       title: "View",
//       dataIndex: "read",
//       key: "read",
//       width: 50,
//       render: (item, record) => (
//         <p>
//           {myPermission?.read_per?.includes(record?.module_key) ? ( //HERE ---------
//             <CheckCircleIcon style={{ color: "green" }} />
//           ) : (
//             <CancelIcon style={{ color: "red" }} />
//           )}

//           {/* <Checkbox style={{ color: "blue" }} defaultChecked /> */}
//         </p>
//       ),
//     },

//     {
//       title: "Create",
//       dataIndex: "create",
//       key: "create",
//       width: 50,
//       render: (item, record) => (
//         <p>
//           {myPermission?.create_per?.includes(record?.module_key) ? ( //HERE ---------
//             <CheckCircleIcon style={{ color: "green" }} />
//           ) : (
//             <CancelIcon style={{ color: "red" }} />
//           )}
//           {/* <Checkbox style={{ color: "blue" }} defaultChecked /> */}
//         </p>
//       ),
//     },
//     {
//       title: "Update",
//       dataIndex: "update",
//       key: "update",
//       width: 50,
//       render: (item, record) => (
//         <p>
//           {myPermission?.update_per?.includes(record?.module_key) ? (
//             <CheckCircleIcon style={{ color: "green" }} />
//           ) : (
//             <CancelIcon style={{ color: "red" }} />
//           )}
//           {/* <Checkbox style={{ color: "blue" }} defaultChecked /> */}
//         </p>
//       ),
//     },

//     {
//       title: "Delete",
//       dataIndex: "delete",
//       key: "delete",
//       width: 50,
//       render: (item, record) => (
//         <p>
//           {myPermission?.delete_per?.includes(record?.module_key) ? (
//             <CheckCircleIcon style={{ color: "green" }} />
//           ) : (
//             <CancelIcon style={{ color: "red" }} />
//           )}
//           {/* <Checkbox style={{ color: "blue" }} defaultChecked /> */}
//         </p>
//       ),
//     },
//     {
//       title: "Download",
//       dataIndex: "download",
//       key: "download",
//       width: 50,
//       render: (item, record) => (
//         <p>
//           {myPermission?.download_per?.includes(record?.module_key) ? (
//             <CheckCircleIcon style={{ color: "green" }} />
//           ) : (
//             <CancelIcon style={{ color: "red" }} />
//           )}
//           {/* <Checkbox style={{ color: "blue" }} defaultChecked /> */}
//         </p>
//       ),
//     },
//   ];
//   useEffect(() => {
//     getData();
//   }, []);

//   const getData = async () => {
//     const data = await getModule();
//     if (data.error)
//       dispatch({
//         type: "SET_ERROR_MESSAGE",
//         errMess: { message: data.error, type: "error" },
//       });
//     else if (data) {
//       setRows(data);
//       setCount(10);
//     }
//   };

//   return (
//     <CustomizedTable
//       setRows={setRows}
//       setPageSize={setPageSize}
//       setPage={setPage}
//       pageSize={pageSize}
//       page={page}
//       count={count}
//       columns={columns}
//       rows={rows}
//       title={"Permission"}
//     />
//   );
// };

// export default PermissionTable;
